export * from './invoice-item.model';
export * from './invoice-item.service';




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/invoice-item/index.ts